import { addHours, differenceInHours, subDays, subHours } from 'date-fns';
import React from 'react';
import { DateRange } from 'react-day-picker';

import { TimeMarker } from '@/components/route-segment-panel/segment-schedules/time-marker';
import { RouteLocationInterface } from '@/types';
import { cn } from '@/utils/styles';

interface TimeMarkersProps {
  timeRangeHours?: number;
  origin: RouteLocationInterface;
  destination: RouteLocationInterface;
  dateRange: DateRange;
  departHour?: number;
  arriveHour?: number;
  className?: string;
}

export const TimeMarkers = ({
  timeRangeHours = 0,
  origin,
  destination,
  dateRange,
  departHour,
  arriveHour,
  className,
}: TimeMarkersProps) => {
  if (!dateRange.from || !dateRange.to) return null;

  const hoursBetweenDates = differenceInHours(dateRange.to, dateRange.from);

  return (
    <div className={cn('pointer-events-none absolute bottom-0 left-2 right-2 z-6 px-8', className)}>
      <div className="grid h-full grid-cols-[var(--timeline-grid-cols)] pl-8">
        <div />
        <div className="relative left-0">
          {departHour && departHour >= 0 ? (
            <TimeMarker
              position={(1 / timeRangeHours) * departHour * 100}
              date={addHours(dateRange.from, departHour)}
              origin={origin}
              destination={destination}
            />
          ) : null}
          {arriveHour && arriveHour >= 0 ? (
            <TimeMarker
              position={(1 / timeRangeHours) * (hoursBetweenDates - (24 - arriveHour)) * 100}
              date={subHours(subDays(dateRange.to, 1), 24 - arriveHour)}
              origin={origin}
              destination={destination}
              isOriginMarker={false}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
